import React from 'react'
import { Separator, Row, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import PillButton from './PillButton'
import useArchiveSession from '../../components/dashboard/hooks/useArchiveSession'
import AreYouSureArchiveOverlay from '../../components/dashboard/components/overlays/AreYouSureArchiveOverlay'
import useAttachmentMutation from '../../components/dashboard/hooks/useAttachmentMutation/useAttachmentMutation'
import { isSessionDetail, isConferencePromo, isAttachmentDetail } from '../helpers'

export default function ArchiveActionsButtons({ data, removeData }) {
  const { archiveSessionMutation } = useArchiveSession()
  const { deleteAttachment } = useAttachmentMutation()
  const areYouSureOverlay = useOverlay()
  const [t] = useTranslation()
  const isSession = isSessionDetail(data)
  const isAttachment = isAttachmentDetail(data)
  const isPromo = isConferencePromo(data)

  const onArchiveClick = () => {
    if (isSession) {
      archiveSessionMutation(data)
      removeData(data.id)
    }
    if (isAttachment) {
      removeData(data.id)
      deleteAttachment(data)
    }
    if (isPromo) {
      removeData(data.promoId)
    }
  }

  return (
    <>
      <Separator size="xs" />
      <Row gutters="md">
        <PillButton emphasis="medium" onClick={areYouSureOverlay.handleClick}>
          {t('dashboard.past-sessions.archive-button', 'Archive')}
        </PillButton>
      </Row>
      {(areYouSureOverlay.isOpen || areYouSureOverlay.transitioning) && (
        <AreYouSureArchiveOverlay {...areYouSureOverlay} onArchive={onArchiveClick} />
      )}
    </>
  )
}
